










































































































































import { Prop, Component, Vue } from "vue-property-decorator";
import InvoiceItemViewModel from "../presenters/invoice-item-view-model";
import InvoiceRow from "./InvoiceRow.vue";
import VTd from "./VTd.vue";
import SelectOption from "../../../common/ui/presenters/select-option";
import { ESTIMATE_ITEM_LEVEL } from "@/preferences";

@Component({
  computed: {
    ESTIMATE_ITEM_LEVEL() {
      return ESTIMATE_ITEM_LEVEL;
    }
  },
  components: {
    VTd,
    InvoiceRow
  }
})
export default class InvoiceItem extends Vue {
  @Prop({ required: true }) item!: InvoiceItemViewModel;
  @Prop({ required: true }) unitOptions!: SelectOption[];
  @Prop({ required: true }) styleGridColumn!: string;
  @Prop({ required: true }) level!: number;
  @Prop({ required: true }) expenseCategoryOptions!: SelectOption[];
  @Prop({ required: true }) isFirstItemInLayer!: boolean;

  calculate() {
    this.$emit("calculate");
  }

  isNegative(value: number): boolean {
    return value < 0;
  }

  get disableUpLevel(): boolean {
    return this.level === ESTIMATE_ITEM_LEVEL.PARENT;
  }

  get disableDownLevel(): boolean {
    const isGrandChild: boolean =
      this.level === ESTIMATE_ITEM_LEVEL.GRAND_CHILD;
    const isChildHasGrandChild: boolean =
      this.level === ESTIMATE_ITEM_LEVEL.CHILD && this.item.items.length > 0;
    const isParentHasGrandChild: boolean =
      this.level === ESTIMATE_ITEM_LEVEL.PARENT &&
      this.item.items.length > 0 &&
      this.item.items.some(child => child.items.length > 0);
    return (
      isGrandChild ||
      isChildHasGrandChild ||
      isParentHasGrandChild ||
      this.isFirstItemInLayer
    );
  }
}
